import { render, staticRenderFns } from "./CustomerTile.vue?vue&type=template&id=4da90dec&"
import script from "./CustomerTile.vue?vue&type=script&lang=js&"
export * from "./CustomerTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports